import DadosEmpresa from "./dados-empresa.model";
import { TipoDeProcessoEnum } from "../../enums/legalize.enum";

const TIPO_DE_PROCESSO_DEFAULT = TipoDeProcessoEnum.LEGALIZACAO
/**
 * Modelo de objeto para Novo Processo do eLegalize;
 * @class ProcessoElegalize
 * @namespace ProcessoElegalize
 */
export default class ProcessoElegalize {
  /**
   * Construção basica do objeto de novo Processo
   * @param {Number} id - ID do processo
   * @param {String} tipoDeProcessoId - ID do tipo de processo
   * @param {String} nomeNegocio - Nome do Negócio
   * @param {String} detalheNegocio - Detalhes do negócio
   * @param {String} pessoaContatoNome - Nome da pessoa de contato
   * @param {String} pessoaContatoEmail - E-mail da pessoa de contato
   * @param {String} pessoaContatoWpp - Whatsapp da pessoa de contato
   * @param {String} templateId - Id do template do processo
   * @param {String} dataPrevisaoConclusao - Data de previsão da conclusão do processo em string
   * @param {DadosEmpresa} formularioProcesso - Dados da empresa
   * @param {Number} empresaId - Id da empresa
   * @param {Number} tarefaId - Id da tarefa do processo
   * @param {Array} anexos - Anexos da tarefa do processo
   * @constructor
   */
  constructor(
    id = null,
    tipoDeProcessoId = TIPO_DE_PROCESSO_DEFAULT,
    nomeNegocio = '',
    detalheNegocio = '',
    pessoaContatoNome = '',
    pessoaContatoEmail = '',
    pessoaContatoWpp = '',
    templateId = '',
    dataPrevisaoConclusao = '',
    formularioProcesso = new DadosEmpresa(),
    empresaId = null,
    tarefaId = null,
    anexos = []
  ) {
    this.id = id;
    this.tipoDeProcessoId = tipoDeProcessoId;
    this.nomeNegocio = nomeNegocio;
    this.detalheNegocio = detalheNegocio;
    this.pessoaContatoNome = pessoaContatoNome;
    this.pessoaContatoEmail = pessoaContatoEmail;
    this.pessoaContatoWpp = pessoaContatoWpp;
    this.templateId = templateId;
    this.dataPrevisaoConclusao = dataPrevisaoConclusao;
    this.formularioProcesso = formularioProcesso;
    this.empresaId = empresaId;
    this.tarefaId = tarefaId;
    this.anexos = anexos;
  }

  /**
   * Atualiza modelo com dados válidos de um objeto com dados de
   * formulário;
   * @param {Object} formData Objeto com dados do formulário
   */
  updateDados(formData) {
    for (let propriedade in formData) {
      if (!Object.keys(formData).includes(propriedade)) {
        console.warn(`WARN: Propriedade "${propriedade}" não é valido para modelo`);
        continue;
      }
      this[propriedade] = formData[propriedade];
    }
  }

  /**
   * Formata e trata, se necessário dados do modelo para ser inserido no body de um request
   * @returns {Object} Objeto formatado para body da requisição;
   */
  asRequestBody(cleanBody = true) {
    const dataFormatada = this.dataPrevisaoConclusao.replace(/([0-9]{2})\/([0-9]{2})\/([0-9]{4})/, '$3-$2-$1');
    const body = {
      id: this.id,
      tipoDeProcessoId: this.tipoDeProcessoId,
      nomeNegocio: this.nomeNegocio,
      detalheNegocio: this.detalheNegocio,
      pessoaContatoNome: this.pessoaContatoNome,
      pessoaContatoEmail: this.pessoaContatoEmail,
      pessoaContatoWpp: this.pessoaContatoWpp,
      templateId: this.templateId,
      dataPrevisaoConclusao: dataFormatada,
      formularioProcesso: this.formularioProcesso.asRequestBody(cleanBody),
      tarefaId: this.tarefaId,
      empresa: {
        id: this.empresaId
      }
    };

    if(cleanBody) {
      this.cleanBody(body);
    }
    
    return body;
  }

  asModel(response) {
    this.id = response.id;
    this.tipoDeProcessoId = response.tipoDeProcessoId;
    this.nomeNegocio = response.nomeNegocio;
    this.detalheNegocio = response.detalheNegocio;
    this.pessoaContatoNome = response.pessoaContatoNome;
    this.pessoaContatoEmail = response.pessoaContatoEmail;
    this.pessoaContatoWpp = response.pessoaContatoWpp;
    this.templateId = response.templateId;
    this.dataPrevisaoConclusao = response.dataPrevisaoConclusao.replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$1-$2-$3');

    if(response.formularioProcesso) {
      this.formularioProcesso.asModel(response.formularioProcesso);
    }

    this.empresaId = response.empresa.id;
    if(response.tarefa) {
      this.tarefaId = response.tarefa.id;
    }
    this.anexos = response.anexos;
  } 

  /**
   * Limpa do objeto campos vazios antes de enviar o request para o back;
   * @param {Object} body - body do request
   */
  cleanBody(body) {
    for (const prop in body) {
      if (body[prop] === '' || body[prop] === null || (Array.isArray(body[prop]) && body[prop].length == 0)) {
        delete body[prop]
      }
    }
  }
}
